module.exports = __webpack_public_path__ + "static/media/2.07f0ecce.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/gomel/2.JPG
// module id = 220
// module chunks = 0